var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"left-area"},[_c('div',{staticClass:"content"},[_vm._t("content")],2)]),_c('div',{staticClass:"right-area only-on-large"},[_c('div',{staticClass:"drawer"},[_vm._t("drawer")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }